module.exports = __webpack_public_path__ + "img/part-5-title.65564f01.png";